import { getSize } from '../theme/iconSizes'
import IconProps from './Icon'

const ArrowDown = ({ iconSize, strokeWidth = 3, stroke = 'currentColor' }: IconProps) => {
  const size = getSize(iconSize)

  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <polyline points="1 7 12 17 23 7" stroke={stroke} strokeWidth={strokeWidth} />
      </g>
    </svg>
  )
}

export default ArrowDown
